export default __webpack_public_path__ + "static/19-bc6889ea10f24e2ab113d86af7717ed8.webp";